import type { Mission } from '@/features/loader/types';
import { VISUAL } from '@/features/loader/constants';
import { NOAA_CATALOGUE } from '@/features/loader/catalog/noaaCatalogue';

export const JASON_NORAD_ID = '41240';
export const TLE_ASSET_IDS: Record<string, string> = {
  ...Object.fromEntries(NOAA_CATALOGUE.entries.filter(e => e.orbitType !== 'L1').map(e => [`noaa_reference:${e.id}`, String(e.noradId)])),
  senseSat_01: JASON_NORAD_ID,
  suomi_npp: '37849',
  noaa21: '54234',
};

export function missionForOrbitalAsset(missions: Mission[], assetId: string): Mission | undefined {
  const norad = TLE_ASSET_IDS[assetId];
  if (!norad) return undefined;
  return missions.find(
    (m) =>
      String(m.noradId) === norad &&
      m.orbit.tle?.line1.slice(2, 7).trim() === norad &&
      m.orbit.tle.line2.slice(2, 7).trim() === norad,
  );
}
/** Identity must match both TLE lines; never put another mission in this model. */
export function jasonMission(missions: Mission[]): Mission | undefined {
  return missions.find((m) => {
    const tle = m.orbit?.tle;
    return (
      (String(m.noradId) === JASON_NORAD_ID || /jason[-_ ]?3/i.test(`${m.id} ${m.name}`)) &&
      tle?.line1.slice(2, 7).trim() === JASON_NORAD_ID &&
      tle.line2.slice(2, 7).trim() === JASON_NORAD_ID
    );
  });
}

/** Matches the loader's conservative freshness cues, calculated at display time. */
export function orbitFreshness(epochMs: number, timeMs: number): 'recent' | 'ageing' | 'stale' {
  const age = Math.abs(timeMs - epochMs) / 86_400_000;
  return !Number.isFinite(age) || age > VISUAL.TLE_STALE_DAYS
    ? 'stale'
    : age > VISUAL.TLE_WARN_DAYS
      ? 'ageing'
      : 'recent';
}
